import { baseApi } from "@/redux/api/baseApi";

const videoSetupApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVideoSetup: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/video-setup/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: ["videoSetup"],
    }),
    getVideoScript: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/video-script/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: ["videoScript"],
    }),
    createSetup: builder.mutation({
      query: (payload) => ({
        url: `/video-setup/create-setup/${payload.order_id}/${payload.video_id}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["videoSetup"],
    }),
    getVideoSetupFiles: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/video-setup/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: ["videoSetup"],
    }),
    uploadNewSetup: builder.mutation({
      query: ({ orderId, videoId, data }) => ({
        url: `/video-setup/upload-new-setup/${orderId}/${videoId}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["videoSetup", "OrderDetails"],
    }),
    requestSetupRevision: builder.mutation({
      query: (payload) => ({
        url: `/video-setup/request-revision/${payload.order_id}/${payload.video_id}`,
        method: "POST",
        body: payload.data,
      }),
      invalidatesTags: ["videoSetup"],
    }),
    approveSetup: builder.mutation({
      query: (payload) => ({
        url: `/video-setup/approve-setup/${payload.order_id}/${payload.video_id}`,
        method: "POST",
      }),
      invalidatesTags: ["videoSetup", "OrderDetails"],
    }),

    requestVideoSetupTimeLineExtension: builder.mutation({
      query: ({ orderId, videoId, body }) => ({
        url: `/video-setup/request-an-extension/${orderId}/${videoId}`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["videoSetup"],
    }),
  }),
});

export const {
  useRequestSetupRevisionMutation,
  useGetVideoSetupQuery,
  useCreateSetupMutation,
  useApproveSetupMutation,
  useUploadNewSetupMutation,
  useGetVideoSetupFilesQuery,
  useRequestVideoSetupTimeLineExtensionMutation,
} = videoSetupApi;
